export default class StickyHeader {
	observedSection;
	bodyObserver;
	isObservingSection;

    constructor({
        observedSection,
        rootMargin = 0,
        triggerCallback = () => {}
    }) {
        if (!observedSection) {
            throw new Error('No observed section');
        }
		this.observedSection = document.querySelector(observedSection);
        if (this.observedSection && ('IntersectionObserver' in window)) {

            this.isObservingSection = false;
            let options = {
                root: null,
                rootMargin: rootMargin,
                threshold: [0.0, 1.0]
            }
            this.bodyObserver = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            this.hideSticky()
                        } else {
                            this.showSticky()
                        }
                    })
                },
                options
            );

            if (triggerCallback()) {
                this.initObserver();
            } else {
                this.showSticky();
            }


            window.addEventListener('resize', () => {
                if (triggerCallback()) {
                    if (!this.isObservingSection) {
                        this.initObserver();
                    }
                } else {
                    if (this.isObservingSection) {
                        this.destroyObserver();
                    }
                }
            })
        } else {
            this.showSticky();
        }
	}
	
	initObserver(){
		document.body.classList.add('sticky-header')
		this.bodyObserver.observe(this.observedSection);
		this.isObservingSection = true;
	}

	destroyObserver(){
		document.body.classList.remove('sticky-header')
		this.bodyObserver.unobserve(this.observedSection);
		this.isObservingSection = false;
		this.showSticky();
	}

    showSticky() {
        document.body.classList.add('sticky-header-visible')
        document.body.classList.remove('sticky-header-hidden')
    }

    hideSticky() {
        document.body.classList.add('sticky-header-hidden')
        document.body.classList.remove('sticky-header-visible')
    }
}